import { useBreakpoint } from '@one-thd/sui-atomic-components';

export const useMobileBreakpoint = (options = {}) => {
  const { lesser: isMobile } = useBreakpoint('lg', options);

  return isMobile;
}